export enum DeployStatus {
  DEPLOYING = 'deploying',
  DEPLOYED = 'deployed',
  FAILED = 'failed',
  // Terminated instances will be permanently deleted so this state will most likely not exist
  TERMINATED = 'terminated',
  TERMINATING = 'terminating',
  TERMINATION_FAILED = 'termination_failed',
  CONFIGURING = 'configuring',
  CONFIGURED = 'configured',
  CONFIGURATION_FAILED = 'configuration_failed',

  NOT_DEPLOYED = 'not deployed',
  UPDATING = 'updating',
  UPDATED = 'updated',
  UPDATE_FAILED = 'update_failed',
  TESTING = 'testing',
  TESTED = 'tested',
  TEST_FAILED = 'test_failed',
  FAILOVER_APPLYING = 'failover_applying',
  FAILBACK_APPLYING = 'failback_applying',
  PRE_FAILBACK_APPLYING = 'pre_failback_applying',
  FAILOVER_FAILED = 'failover_failed',
  FAILBACK_FAILED = 'failback_failed',
  PRE_FAILBACK_FAILED = 'pre_failback_failed',
  STARTING = 'starting',
  START_FAILED = 'start_failed',
  STOPPING = 'stopping',
  STOPPED = 'stopped',
  STOP_FAILED = 'stop_failed',
  OPERATION_INPROGRESS = 'operation_inprogress',
}

export const deployStatuses = Object.values(DeployStatus);
